const marketingDescriptor = {
    key: 'marketing-expenses',
    title: 'Marketing Expenses',
    subtitle: 'Campaign and channel spend performance',
    description: 'Monitor campaign/channel spend, CAC, and pacing so you can rebalance budgets quickly and keep acquisition efficient.',
    badge: { direction: 'down', text: '' },
    kpis: [
        { label: 'Total Marketing Cost', value: '', subtext: '', subColor: '#eb9d00' },
        { label: 'Perfect P&L Variance', value: '', subtext: '', subColor: '#eb9d00' },
        { label: 'Perfect P&L Income', value: '', subtext: '', subColor: '#43a047' },
    ],
    alert: {
        title: 'Your marketing is performing well!',
        body: 'Meta Ads is crushing it at $221 CPA with 21x ROI. You have $7,740 in budget headroom at your 8% target. Quick Tip: Scale Meta by $1,800/month and test Google at +$500. Pause Print/Mailers immediately and reallocate that $600.',
    },
    lineChart: {
        label: 'Marketing Spend',
        values: [],
        target: null,
    },
    donut: {
        slices: [],
    },
    table: {
        rows: [],
        total: { thisMonth: null, lastMonth: null, changePct: null },
    },
    vendors: [],
};

export default marketingDescriptor;
